<div class="container pt-5 admin">
    <h2 class="mb-4">Create password</h2>

    <form class="row g-3" (ngSubmit)="create_password(email)">
        <div class="col-auto">
            <label class="col-form-label" for="email">Email</label>
        </div>
        <div class="col-5">
            <input class="form-control" type="email" name="email" id="email" [(ngModel)]="email">
        </div>
        <div class="col-auto">
            <button class="btn btn-primary" role="button" type="submit">Create</button>
        </div>
    </form>

    <div [hidden]="!token_url">
        <a id="token" href="{{token_url}}" target="_blank">{{token_url}}</a>
    </div>
</div>